import { useCallback, useContext, useEffect } from "react";
import { PAGE_HOME } from "~/constants/page";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { I18nWrapperContext } from "~/providers/I18nProvider";
import { saveUserPreference } from "~/storages/preference";
import {
  PostMessage,
  PostMessageSession,
  PostMessageTypes,
  PostMessageUserPreference,
} from "~/types/postMessageTypes";
import { UserPreferenceMeasurements } from "~/types/preference";

const PostMessageHandler = () => {
  const { setLocale } = useContext(I18nWrapperContext);
  const { handleSetToken } = useAuthenticationContext();

  const sessionMessageHandler = useCallback(
    (data: PostMessageSession) => {
      handleSetToken(data.token);
      if (window.location.pathname !== PAGE_HOME) {
        window.location.href = PAGE_HOME;
      }
    },
    [handleSetToken],
  );

  const userPreferenceMessageHandler = useCallback(
    (data: PostMessageUserPreference) => {
      saveUserPreference(
        data.isImperial
          ? UserPreferenceMeasurements.Imperial
          : UserPreferenceMeasurements.Metric,
      );

      setLocale(data.language);
    },
    [setLocale],
  );

  const messageHandler = useCallback(() => {
    window.onmessage = (event: MessageEvent<PostMessage>) => {
      if (!event?.data) return;

      switch (event.data.type) {
        case PostMessageTypes.COPILOT_SESSION:
          sessionMessageHandler(event.data as PostMessageSession);
          break;
        case PostMessageTypes.USER_PREFERENCES:
          userPreferenceMessageHandler(event.data as PostMessageUserPreference);
          break;

        default:
          break;
      }
    };
  }, [sessionMessageHandler, userPreferenceMessageHandler]);

  useEffect(() => {
    messageHandler();
  }, [messageHandler]);

  return null;
};

export default PostMessageHandler;
